import { INSTANCE_NAME_STORAGE_KEY } from '../constants';
import type { InstanceListOption } from '../types';

export function findInstanceByName(
  instancesList: InstanceListOption[] | null | undefined,
  name: string | null | undefined
): InstanceListOption | null {
  if (!name || !instancesList?.length) {
    return null;
  }

  const normalizedName = name.trim().toLowerCase();

  return instancesList.find(({ label }) => label.trim().toLowerCase() === normalizedName) ?? null;
}

export function getStoredInstanceByName(
  instancesList: InstanceListOption[] | null | undefined
): InstanceListOption | null {
  return findInstanceByName(instancesList, sessionStorage.getItem(INSTANCE_NAME_STORAGE_KEY));
}
